export default __webpack_public_path__ + "static/media/case3 (2).4cdc0187.jpg";